import StatCard from '@/components/StatCard';
import { STABILITY_LEVELS } from '@/lib/constants';

const countBy = (rows, pred) => rows.filter(pred).length;

const AdminStatsCards = ({ assessments }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
    <StatCard label="Total Assessments" value={assessments.length} />
    <StatCard label="New Leads" value={countBy(assessments, a => a.lead_status === 'New')} />
    <StatCard label="Converted" value={countBy(assessments, a => a.lead_status === 'Converted')} />
    <StatCard label="High Stability" value={countBy(assessments, a => a.stability_level === STABILITY_LEVELS.HIGH)} />
  </div>
);

export default AdminStatsCards;
